// extracted by mini-css-extract-plugin
export default {"WelcomeSection":"webpack-pages-DataExtraction-DataExtractionTemplate-components-WelcomePanel-WelcomePanel-module__WelcomeSection"};